import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUploadIndicator = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 75 74"
    {...props}
  >
    <path
      fill="#292A33"
      fillRule="evenodd"
      d="M37.628.184c20.27 0 36.7 16.436 36.7 36.699 0 20.27-16.43 36.703-36.7 36.703C17.363 73.586.936 57.154.936 36.883c0-20.263 16.427-36.7 36.692-36.7"
      clipRule="evenodd"
    />
    <path
      stroke="#FEFEFE"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={22.926}
      strokeWidth={2.994}
      d="M56.01 43.011v2.45c0 3.429 0 5.145-.668 6.452a6 6 0 0 1-2.68 2.676c-1.306.675-3.023.675-6.456.675H29.054c-3.428 0-5.145 0-6.456-.675a6.02 6.02 0 0 1-2.679-2.676c-.668-1.307-.668-3.023-.668-6.452v-2.45m28.59-14.298-10.208-10.21m0 0L27.42 28.714m10.212-10.21v24.508"
    />
  </svg>
);
export default SvgUploadIndicator;
